<template>
    <div v-html="html"></div>
</template>

<script>
const normalizeCount = (value) => {
    const count = Number(value);
    if (!Number.isFinite(count) || count < 1) {
        return 1;
    }
    return Math.min(count, 3);
};

const toContents = (count, contents, widths) => {
    const base = Array.isArray(contents) ? contents : [];
    const widthList = Array.isArray(widths) ? widths : [];
    const items = [];
    for (let i = 0; i < count; i += 1) {
        items.push({
            content: base[i] || '',
            width: widthList[i] || '',
        });
    }
    return items;
};

export const buildDefaultHtml = (props = {}) => {
    const count = normalizeCount(props.columns);
    const padding = props.padding || '8px';
    const align = props.align || 'left';
    const background = props.backgroundColor ? `background:${props.backgroundColor};` : '';
    const rowHeight = props.rowHeight ? `height:${props.rowHeight};` : '';
    const contents = toContents(count, props.contents, props.widths);
    const cols = contents.map((item) => (
        `<td style="padding:${padding};vertical-align:top;text-align:${align};${background}${item.width ? `width:${item.width};` : ''}">${item.content || ''}</td>`
    )).join('');
    return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0"><tr style="${rowHeight}">${cols}</tr></table>`;
};

export default {
    name: 'MailingBlockColumns',
    props: {
        html: { type: String, default: '' },
        columns: { type: Number, default: 1 },
    },
};
</script>
